const canvasPerioSx = (theme) => ({
    perioContainer: {
        width: '100%',
        height: '100%',
        minHeight: '100%',
    },
});

export default canvasPerioSx;
